module.exports = __webpack_public_path__ + "static/img/userPhoto.a56ead7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userPhoto.jpg
// module id = 7BLK
// module chunks = 1